export default __webpack_public_path__ + "static/media/Gloves of the Sanguine Disciple (nm).c64defff.jpg";